import {useCallback, useState} from 'react';

export const useToggle = (opened: boolean): [boolean, () => void] => {
	const [isOpened, setIsOpened] = useState(opened);

	const toggleOpened = useCallback(() => {
		setIsOpened(!isOpened);
	}, [isOpened]);

	return [isOpened, toggleOpened];
};
